<div class="modal--generic">
  <h1 class="modal__header">ALIR and 1035 Exchanges Coming Soon</h1>
  <div class="modal__body">
    <p class="modal__text">
      You've indicated that you are replacing an existing policy with a new Whole Life application.
      <br />
      <br />
      Please note: ALIR and 1035 Exchanges are not currently supported on Coverpath.
      <br />
      <br />
      If you intend to apply for a policy with ALIR or need to conduct a 1035 Exchange, please contact your financial
      professional.
    </p>
  </div>
  <div class="modal__actions modal__actions--inline">
    <button class="button button--blue button--primary modal__button" (click)="confirm()">Continue</button>
    <button class="button button--blue button--secondary button--no-border modal__button" (click)="cancel()">
      Go Back
    </button>
  </div>
</div>
